import React, { FC } from 'react'

import { IconDealsProps } from './IconDeals.types'
import * as Styled from './styles/IconDeals.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDeals: FC<IconDealsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDealsProps['size'],
  isResponsive = false,
}: IconDealsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='m34.407 27.305 4.286 2.475a2.474 2.474 0 1 1-2.475 4.285L25.5 27.88m8.572 4.948a2.478 2.478 0 0 1 .905 3.382 2.475 2.475 0 0 1-3.38.905l-8.572-4.95'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M29.457 35.877a2.472 2.472 0 0 1-.597 4.526 2.471 2.471 0 0 1-1.877-.248l-.288-.165-16.572-9.563-.285-.162A9.9 9.9 0 0 1 6.215 16.75l2.475-4.285A9.898 9.898 0 0 1 22.21 8.84l.863.5m4.899 14.255L38.7 29.783A2.475 2.475 0 0 0 42.327 27a2.471 2.471 0 0 0-1.152-1.501'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M41.478 24.957a9.857 9.857 0 0 0 1.317-4.524c.15-3.563.07-12.928.07-12.928s-12.782.07-14.57.133a9.893 9.893 0 0 0-8.25 4.944l-6.5 10.825a.249.249 0 0 0 .035.303.25.25 0 0 0 .09.06l1.5.56a3.035 3.035 0 0 0 3.128-.615l4.265-4.64c2.937 1.25 4.952.44 6.607-.5l12 6.92.308-.538Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconDeals
